module.exports = {
          srcSet: __webpack_public_path__ + "44d985e034fda2c817f1ed3de7c6a4d6-549.png"+" 549w",
          images:[ {path: __webpack_public_path__ + "44d985e034fda2c817f1ed3de7c6a4d6-549.png",width: 549,height: 962}],
          src: __webpack_public_path__ + "44d985e034fda2c817f1ed3de7c6a4d6-549.png",
          toString:function(){return __webpack_public_path__ + "44d985e034fda2c817f1ed3de7c6a4d6-549.png"},
          
          width: 549,
          height: 962
        }